$( document ).ready(function() {
    
    $(window).trigger('resize');

    //Age gate exit
    $('#exitAgeGate').on('click',function(){
        window.location.replace("https://google.com");
    });

        //Header menu nav
    $header = $('.header');
    $headerHeight = $header.outerHeight();

    //set dropdown position
    $('.dropdown-menu').css("top",$headerHeight);

    // toggle mobile nav/dropdown
    $('.icon-hamburger').on('click',function(e){
        if($(window).width() >= 750){
            $('.dropdown-menu').toggleClass('hide shown');
           
            e.stopPropagation();
            
            $(document).click(function() { 
                if($('.dropdown-menu').hasClass('shown')){
                    $('.dropdown-menu').toggleClass('hide shown');
                }
            });
            
        }else{
            $('body').toggleClass('fixedPosition');
            $('.mobile-nav').toggleClass('hide shown');
        }
    });

    // Mobile nav - close
	$('.icon-close').click(function(e){
		e.preventDefault();
        $('.mobile-nav').toggleClass('hide shown');
        $('body').toggleClass('fixedPosition');
	});

    //update cart when load
    getCartItem();
  
    //update cart icon when add to cart
    $('.product-description__button').on('click',function(){
        // show add to cart popup on non-cart page
        if(!$('body').hasClass('template-cart')){
            if (!$('.popup__confirm__cart').hasClass('active')){
                $('.popup__confirm__cart').addClass('active');
            }
        }
        
        setTimeout(function(){ 
            getCartItem();
        }, 3000);
    });

    function getCartItem(){
        jQuery.getJSON('/cart.js', function(cart) {
            // now have access to Shopify cart object
            if(cart.item_count > 0){
                $('.bag-added').addClass('shown');
                    if($('body').hasClass('template-cart')){
                        setTimeout(function(){ 
                            if($('.cart-item__remove, .cart-item__spinner').length > 0){
                                $('.cart-item__remove, .cart-item__spinner').on('click',function(){
                                    setTimeout(function(){ 
                                        getCartItem();
                                    }, 1000);
                                });
                            }
                        }, 1000);
                    }
            }else{
                $('.bag-added').removeClass('shown');
            }
        } );
    }


    //close popup
    $('.popup__close').on('click',function(){
        if ($('.popup__confirm__cart').hasClass('active')){
            $('.popup__confirm__cart').removeClass('active');
        }
    });


    //Clientelle logo slider - fade effect
    if($('.clientelle-logos').length >0){
        $('.clientelle-logos').slick({
            draggable: true,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: false,
            fade: true,
            speed: 500,
            infinite: true,
            slidesToShow: 1,
            cssEase: 'ease-in-out',
            touchThreshold: 100
        });
    }
    
    var iframe = $('#video-banner__iframe')[0];
    if(iframe){
        var player = new Vimeo.Player(iframe);
        // show and play video in Brand landing page
        $('.video-banner__icon').on('click', function() {
            if(player != undefined){
                $('.video-banner__wrapper').addClass('active');
                player['play']();   
            }
        });
    }

    var video = $('.video')[0];

    if (video) {
        $(".hero-video__play").click(function(e){
            var video_id = $(this).data('video-id');
            var video_image = $(this).siblings('.hero-video__image');
            var video = $('#Mp4Video-' + video_id)[0];

            if (video.paused == true ){
                video.play();
                $(this).addClass('hide');
                video_image.addClass('hide');
            } else {
                //hide banner
                video.pause();
                $(this).removeClass('hide');
            }
        });
    }

    $('.video').click(function(e){

        var video = $(this)[0];
        var video_id = $(this).id;

        if (video.paused == true ){
            video.play();
            $(this).siblings(".hero-video__play").addClass('hide');
        } else {
            //hide banner
            video.pause();
            $(this).siblings(".hero-video__play").removeClass('hide');
        }
    });

    if($('body').hasClass('template-events')){
        var loaded = false;
        $('.event-form-container').addClass('hide');
        
        setTimeout(function(){ 
            if($('.powrLoaded iframe').length > 0){
                loaded = true;
                $('.loader-container').fadeOut();
                $('.event-form-container').removeClass('hide');
            }
        }, 3000);
    }

    // Products filtering
    if ($('body').hasClass("template-collection")) {
        let urlPath = window.location.toString();
        let collectionUrl = urlPath ;
        var collFilters = $('.tag-filters select');
            collFilters.change(function() {
            var newTags = [];
            collFilters.each(function() {
                if ($(this).val() && !$(this).hasClass('sort_by')) {
                    newTags.push($(this).val());
                }
                
            });
            if (newTags.length ) {
                var query = newTags.join('+');
                if($(this).hasClass('sort_by')) {
                    if (urlPath.indexOf("?") > 0) {
                        collectionUrl = urlPath.substring(0, urlPath.indexOf("?"));
                    }
                    sortValue = $(this).val();
                    window.location.href = collectionUrl + '?sort_by=' + sortValue;
                }else{
                    window.location.href = $('.collection').data('collection-url') + '/' + query;
                }
            }
        });


        $('button[type=submit]').on('click',function(e){
            // e.preventDefault();
        });
        
    }

    /* --- Cart Page ----------------------------- */

	if ($('body').hasClass("template-cart")) {

		$('#checkout_button_validate').click(function(e){
			if (!$('#purchasers_age').is(':checked')) {
				e.preventDefault();
				$('label[for="purchasers_age"]').addClass('error');
			}

            if (!$('#receivers_age').is(':checked')) {
				e.preventDefault();
				$('label[for="receivers_age"]').addClass('error');
			}
		})
	}

});  

$( window ).on('resize',function() {
    
    $windowWidth = $(window).innerWidth();
    
    $headerLeft = $('.header__left');
    $headerLeftWidth = $headerLeft.outerWidth();
    $headerLeftNoPaddingWidth = $headerLeft.width();
    $iconHamburger = $('.icon-hamburger');
    $iconHamburgerWidth = $iconHamburger.width();
    $const = $headerLeftNoPaddingWidth - $iconHamburgerWidth;
    $headerLeftWidthValue = parseFloat($headerLeftWidth);
    $headerMiddle = $('.header__middle');
    $headerMiddleWidth = $headerMiddle.outerWidth();
    $headerRight = $('.header__right');
    $headerRightWidth = $headerRight.outerWidth();

    $headerMiddleCalculatedWidth = $windowWidth - $headerLeftWidthValue - $headerRightWidth;

    $headerMiddleMenuItems = $('.header__middle .main-nav li');
    $headerMiddleMenuItems_last = $('.header__middle .main-nav li:last-child');
    $numberOfMenuItems = $headerMiddleMenuItems.length;
    
    $headerMiddle.css('width',$headerMiddleCalculatedWidth + 'px');
    
    $headerMiddleMenuItemsWidth = ($headerMiddleCalculatedWidth - $const) / $numberOfMenuItems;

    $headerMiddleMenuItems.css('width',$headerMiddleMenuItemsWidth+'px');
    $headerMiddleMenuItems_last.css('width', ($headerMiddleMenuItemsWidth + $const) +'px');

    $firstmenuWidth = $('.main-nav li:first-child').outerWidth();
    $firstmenuWidthValue = parseFloat($firstmenuWidth);

    $dropdownMenuWidth = $headerLeftWidthValue + $firstmenuWidthValue;
    $secondDropdownMenuWidth = $firstmenuWidthValue * 2;
    
    $dropdownMenuImageWrapperWidth = $windowWidth - $dropdownMenuWidth - $secondDropdownMenuWidth;


    
    $('.dropdown-menu-nav').css('width',$dropdownMenuWidth + 'px');
    $('.dropdown-menu-nav-second').css('width',$secondDropdownMenuWidth + 'px');
    $('.dropdown-menu__wrapper').css('width',$dropdownMenuImageWrapperWidth + 'px');

    if ($('body').hasClass("template-event")) {
        if (  $windowWidth  >= 1024 && $('.collection__list').children().length == 3) {
            $('.collection__list').css('grid-template-columns', '1fr 1fr 1fr');
        }else{
            $('.collection__list').removeAttr('style');
        }
    }
});

